module.exports = __webpack_public_path__ + "img/page3-1.adde1219.png";